import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";
import BuyProject from "./BuyProject";
import "../notes/notes.css";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/projects">
        <Button
          id="back"
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>

      <Grid container justify={"center"} id="topgrid">
        <Grid item xs={12} md={8} sm={12}>
          <Paper className={classes.paper} style={{ color: "black" }}>
            <h1>6th SEM CG PROJECT</h1>
            <Divider />
            <h2>What is CG ?</h2>
            <ul style={{ textAlign: "left" }}>
              <p>
                Computer graphics have become powerful tool for the rapid and
                economical production of pictures. Development in computer
                graphics have had a profound impact on many types of media and
                revolutionised animation, movies and the video game industry.
                The main aim of this Mini Project is to illustrate the concepts
                and usage of pre-built functions in OpenGL.
              </p>
            </ul>
            <Divider />
            <h2>What topic should you choose ?</h2>
            <img
              src="data:image/png;base64,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"
              alt="choose your topic"
            />
            <ul style={{ textAlign: "left" }}>
              <li>
                The student has to choose a topic which is distinct from others.
              </li>
              <li>
                The topic can be any one of the real world application or a new
                idea.{" "}
              </li>
              <p>
                <b>Note:</b>Having an idea or a topic already in your mind will
                help you to process the execution better. So choose your topic
                wisely on the basis of your knowledge.
              </p>
            </ul>
            <Divider />
            <h2>What software to use?</h2>
            <Divider />
            <img
              src="https://visualstudio.microsoft.com/wp-content/uploads/2019/09/visualstudio-newhome.png"
              alt=""
            />
            <br />
            <h4>
              software :microsoft Visual Studio (version 6 or higher){" "}
              <a href="https://visualstudio.microsoft.com/">
                https://visualstudio.microsoft.com
              </a>
            </h4>{" "}
            <br />
            <Divider />
            <h2>Operting system</h2>
            <Divider />
            <h3> Windows / Mac</h3> <br />
            <Divider />
            <h2>Programming languages used</h2>
            <Divider />
            <h3> Language : C++</h3> <br />
            <Divider />
            <h2>OpenGL libraries :</h2>
            <Divider />
            <li>Header Files : glut.h </li>
            <li>
              {" "}
              Object File Libraries : glu32.lib, opengl32.lib, glut32.lib
            </li>
            <li>
              DLL Files(Dynamic Link Files) : glu32.dll, glut32.dll,
              opengl32.dll
            </li>
            <Divider />
            <h2>Procedure for Mac with xcode installed <a href="https://en.wikibooks.org/wiki/OpenGL_Programming/Installation/Mac">click here</a></h2>
            <Divider />
            <Divider />
            <h2>Procedure for Windows</h2>
            <Divider />
            <ul style={{ textAlign: "left" }}>
              <li>
                {" "}
                Download GLUT header, lib, and dll files from{" "}
                <a href="https://www.opengl.org/resources/libraries/glut/glutdlls37beta.zip">
                  OpenGL
                </a>
                . (Mentioned on this{" "}
                <a href="https://www.opengl.org/resources/libraries/glut/glut_downloads.php">
                  page
                </a>
                )
              </li>
              <li>
                {" "}
                Paste glut.h in{" "}
                <strong>
                  C:\Program Files (x86)\Microsoft Visual
                  Studio\2017\Community\VC\Tools\MSVC\&#123;14.16.27023&#125;\include\GL
                </strong>
                .
              </li>
              <p style={{ color: "blue" }}>
                Create the GL folder if not present already. The version may
                differ on your system.
              </p>

              <li>
                {" "}
                Paste glut.lib in{" "}
                <strong>
                  C:\Program Files (x86)\Microsoft Visual
                  Studio\2017\Community\VC\Tools\MSVC\&#123;14.16.27023&#125;\lib\x64
                </strong>
                .
              </li>
              <p style={{ color: "blue" }}>
                Paste glut32.lib in C:\Program Files (x86)\Microsoft Visual
                Studio\2017\Community\VC\Tools\MSVC\&#123;14.16.27023&#125;\lib\x86.
                The version may differ on your system.
              </p>

              <li> Paste glut.dll and glut32.dll in C:\Windows\SysWOW64.</li>
              <p style={{ color: "blue" }}>
                Copy glut32.dll to C:\Windows\System32 also.
              </p>
              <li>
                {" "}
                Open your Windows Console Application project in Visual Studio,
                or create a new one:
              </li>
              <p>
                <strong> New > Project </strong>
              </p>
              <p>
                <strong>
                  {" "}
                  Visual C++ > Windows Desktop > Windows Console Application{" "}
                </strong>
              </p>
              <img
                id="visulstudio"
                src="https://www.absingh.com/assets/images/opengl/newproj.JPG"
                alt=""
              />
              <li> Go to Project > Properties.</li>
              <p>
                <strong>
                  {" "}
                  Select All Configuration from Configuration dropdown menu on
                  top left corner.
                </strong>
              </p>
              <p>
                <strong>
                  {" "}
                  Select Configuration Properties > C/C++ > Precompiled headers
                  and change Precompiled Header option’s value to Not Using
                  Precompiled Headers.
                </strong>
              </p>
              <p>
                <strong>
                  {" "}
                  SSelect Configuration Properties > Linker > Input. Now right
                  click on Additional Dependencies found on right panel and
                  click Edit.
                </strong>
              </p>
              <p>
                <strong> Now type.</strong>
              </p>
              <div style={{ background: "#30475e", color: "white" }}>
                <ol> opengl32.lib</ol>
                <ol> glu32.lib</ol>
                <ol> glut32.lib</ol>
              </div>
              <h6>
                (<strong> Note:</strong> Each .lib in new line)
              </h6>
              <li>
                {" "}
                That’s it. You have successfully installed OpenGL. Go on and run
                your program.
              </li>
              <p style={{ color: "blue" }}>
                Same installation instructions apply to freeglut files with the
                header files in the GL folder, lib in the lib folder, and dll in
                the System32 folder.
              </p>
              <ol>
                {" "}
                <p>
                  {" "}
                  <strong> Check your installation</strong>
                </p>
                <p>
                  {" "}
                  <strong>
                    {" "}
                    You can check your installation by running a simple C++
                    OpenGL program to draw points on a 2D canvas.
                  </strong>
                </p>
               
              </ol>
              <div style={{ backgroundColor: "black", color:'white' }}>
                  <ol>
                  <span style={{color:'yellow'}}>    #include&#60;GL/glut.h&#62; </span><br />
                    void display() &#123; <br />
                    glClear(GL_COLOR_BUFFER_BIT); <br />
                    glColor3f(1.0, 0.0, 0.0); <br />
                    glBegin(GL_POINTS); <br />
                    glVertex2f(10.0, 10.0); <br />
                    glVertex2f(150.0, 80.0); <br />
                    glVertex2f(100.0, 20.0); <br />
                    glVertex2f(200.0, 100.0); <br />
                    glEnd(); <br />
                    glFlush(); <br />
                    &#125; <br />
                    void myinit() &#123; <br />
                    glClearColor(1.0, 1.0, 1.0, 1.0); <br />
                    glColor3f(1.0, 0.0, 0.0); <br />
                    glPointSize(5.0); glMatrixMode(GL_PROJECTION); <br />
                    glLoadIdentity(); <br />
                    gluOrtho2D(0.0, 499.0, 0.0, 499.0); <br />
                    &#125; <br />
                    void main(int argc, char** argv) &#123; <br />
                    glutInit(&argc, argv); <br />
                    glutInitDisplayMode(GLUT_SINGLE | GLUT_RGB); <br />
                    glutInitWindowSize(500, 500); <br />
                    glutInitWindowPosition(0, 0); <br />
                    glutCreateWindow("Points"); <br />
                    glutDisplayFunc(display); <br />
                    myinit(); <br />
                    glutMainLoop(); <br />
                    &#125; <br />
                  </ol>
                </div>
                <h5>Output</h5>
                <img       id="visulstudio" src="https://www.absingh.com/assets/images/opengl/points.jpg" alt=""/>
            </ul>

            <Divider />
          </Paper>
        </Grid>
        <BuyProject />
      </Grid>

     
      <Footer />
    </div>
  );
}
